function bind(fn,thisArg){return function wrap(){return fn.apply(thisArg,arguments)}}

export { bind as default };
//# sourceMappingURL=bind.js.map
